import { memo } from 'react';

import { SoftwareResilienceLogo, Logo } from '@/components/Svg/Images';
import { Separator } from '@/components/ui/separator';

import { type ICertificateType } from '../model';

type Props = {
  title: string;
  description: string | React.ReactNode;
  ref: React.RefObject<HTMLHtmlElement | null>;
  isTerminated?: boolean;
  type: ICertificateType;
};

const CertificateLayout = memo(
  ({ type, title, description, children, isTerminated = false, ref }: React.PropsWithChildren<Props>) => {
    return (
      <section className="border-2 border-border rounded-md bg-white relative" ref={ref}>
        {isTerminated && (
          <img
            className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] max-w-[545px] pointer-events-none z-2 opacity-50"
            src="/assets/certifications/terminated.svg"
            alt="terminated"
          />
        )}
        <div className="flex flex-col justify-between relative p-6 sm:p-8 z-1 h-full overflow-hidden">
          <div className="grow space-y-2 mb-4">
            <div className="flex items-center gap-1.5 mb-8">
              <Logo className="w-17.75 h-3.75" />
              <Separator orientation="vertical" className="h-[7px]" />
              <SoftwareResilienceLogo className="w-[75px] h-[6px]" />
            </div>
            <img
              className="w-[70px] h-[114px] absolute -top-[2px] right-[37px] pointer-events-none"
              src={`/assets/certifications/badges/${type}.svg`}
              alt={type}
            />
            <img
              className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] size-[390px] pointer-events-none"
              src="/assets/certifications/bg-logo.svg"
              alt="logo"
            />
            <h1 className="text-[22px] text-foreground text-center">{title}</h1>
            <p className="text-[11px] leading-[1.8] text-foreground">{description}</p>
            {children}
          </div>

          <div className="flex items-end justify-between gap-6 shrink-0">
            <div className="space-y-1 grow">
              <img
                className="w-[329px] max-w-full pointer-events-none"
                src="/assets/certifications/logo-group.png"
                alt="logo group"
              />
              <p className="text-[8px] text-foreground">
                This document is confidential. Codekeeper terms and conditions apply.
              </p>
            </div>
            <div className="shrink-0">
              <img
                className="w-[58px] mx-auto block! pointer-events-none"
                src="/assets/certifications/signature.png"
                alt="signature"
              />
              <div className="-mt-[7px] border-t border-primary pt-1.5 text-[9px] text-foreground space-y-1.5">
                <strong className="text-bold">Stephanie Dutour Geerling</strong>
                <div>COO, Codekeeper</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  },
);

CertificateLayout.displayName = 'CertificateLayout';

export default CertificateLayout;
